import React, { useState } from "react";
import { useQuery, useQueryClient } from "react-query";

import {
  ModalShell,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useModal,
} from "components/Modal";
import { Button } from "components/Button";
import { Radio } from "components/Radio";
import { RegularText } from "components/Text";
import { LoadingView, ErrorView } from "components/Feedback";

import { getErrorMessage } from "services/api";

import { getClientGroups, updateClient } from "./api";
import styles from "./styles.module.scss";

/** Массовый перенос клиентов в другую группу */
export const ChangeGroupModal = ({ clients, currentGroup, onDone }) => {
  const queryClient = useQueryClient();
  const { closeModal } = useModal();

  const groupsQuery = useQuery(["client-groups"], getClientGroups);
  const groups = groupsQuery.data?.items ?? [];

  const [selectedId, setSelectedId] = useState(
    String(currentGroup?.clientgroupid ?? "")
  );
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const handleMove = async () => {
    if (!selectedId) return;
    setSaving(true);
    setError("");
    try {
      await Promise.all(
        clients.map((client) =>
          updateClient({
            clientgroupid: Number(selectedId),
            clientid: Number(client.clientid),
          })
        )
      );
      queryClient.invalidateQueries(["clients"]);
      onDone?.();
      closeModal();
    } catch (e) {
      setError(getErrorMessage(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <ModalShell width={400}>
      <ModalHeader
        title="Выберите группу для перемещения"
        onClose={closeModal}
      />
      <ModalBody className={styles.changeGroupBody}>
        {groupsQuery.isLoading ? (
          <LoadingView />
        ) : groupsQuery.isError ? (
          <ErrorView
            message={getErrorMessage(groupsQuery.error)}
            onRetry={groupsQuery.refetch}
          />
        ) : (
          groups.map((group) => (
            <div className={styles.changeGroupRow} key={group.clientgroupid}>
              <Radio
                id={`change-group-${group.clientgroupid}`}
                name="change-group"
                label={group.name}
                checked={String(selectedId) === String(group.clientgroupid)}
                onChange={() => setSelectedId(String(group.clientgroupid))}
              />
            </div>
          ))
        )}
        {!!error && (
          <RegularText size={13} color="danger">
            {error}
          </RegularText>
        )}
      </ModalBody>
      <ModalFooter>
        <Button variant="tertiary" onClick={closeModal}>
          Отменить
        </Button>
        <Button
          variant="secondary"
          onClick={handleMove}
          disabled={!selectedId}
          loading={saving}
        >
          Перенести
        </Button>
      </ModalFooter>
    </ModalShell>
  );
};
